import styled from '@emotion/styled';
import React from 'react';
import { mediaQueries } from '../../../style/global-style';
import PinSVG from './../../../../public/static/icons/Pin.svg';
import DirectionArrowSVG from './../../../../public/static/icons/directionArrow.svg';
import { StyledHeader } from '../../atoms/section-headline/section-headline.style';
import { getAssetsPrefix } from '../../../utils/buildVersion';

const assetPrefix = getAssetsPrefix();

export const StyledBgWrapper = styled.section`
    height: 245px;
    max-width: 1920px;
    margin: 0 auto;
    position: relative;
    @media ${mediaQueries.tabletAndUp} {
        height: 195px;
    }

    & > div {
        background-image: url('${assetPrefix}/static/images/ship-position-bg-mobile.jpg');
        background-size: cover;

        @media ${mediaQueries.tabletAndUp} {
            background-image: url('${assetPrefix}/static/images/ship-position-bg-tablet.jpg');
        }
        @media ${mediaQueries.desktopAndUp} {
            background-image: url('${assetPrefix}/static/images/ship-position-bg-desktop.jpg');
        }
    }
`;

export const StyledContent = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    @media ${mediaQueries.tabletAndUp} {
        justify-content: space-around;
        flex-direction: row;
        padding: 18px;
        text-align: left;
    }
`;

export const StyledShipPositionInfo = styled.div`
    margin-bottom: 8px;
    @media ${mediaQueries.tabletAndUp} {
        margin-right: 70px;
    }
`;

export const StyledShipLocation = styled.div`
    font-size: ${(props) => props.theme.fontSize.copyTextL};
    font-weight: 600;
    margin-bottom: 8px;
`;

interface IIcon {
    margin: string;
    height: number;
    fill: string;
    width: number;
    transform: React.CSSProperties['transform'];
}

export const PinLogo = styled(({ margin, transform, ...rest }: IIcon) => <PinSVG {...rest} />)`
    margin: ${(props) => props.margin};
    transform: ${(props) => props.transform};
`;

export const DirectionArrow = styled(({ margin, ...rest }: IIcon) => (
    <DirectionArrowSVG {...rest} />
))`
    margin: ${(props) => props.margin};
`;

export const StyledLatLong = styled.div`
    font-size: ${(props) => props.theme.fontSize.copyTextL};
    margin-bottom: 8px;
    line-height: 1.3;
`;

export const StyledButtonWrapper = styled.div`
    /* margin-top: 20px; */
    @media ${mediaQueries.tabletAndUp} {
        margin: 0;
    }
`;

export const StyledTitleWrapper = styled.section`
    ${StyledHeader} {
        padding-bottom: 0px;
        background-color: transparent !important;
        @media ${mediaQueries.phone} {
            padding: 5px 0 15px;
        }
    }
`;
